module.exports = __webpack_public_path__ + "img/bg_avatar_male_92.e38571fd.png";